import { useRef } from "react";
import TagInput from "@/components/ui/TagInput";

interface CategoryTagInputProps {
  value: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function CategoryTagInput({ value, onChange, disabled, placeholder }: CategoryTagInputProps) {
  const previousValue = useRef<string[]>(value);

  const handleChange = async (newValue: string[]) => {
    const previous = previousValue.current;
    previousValue.current = newValue;

    const added = newValue.filter((v) => !previous.includes(v));
    for (const tag of added) {
      try {
        await fetch("/api/company-classification/terms", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ field: "category", label: tag, source: "user_created", confirmed: true }),
        });
      } catch (error) {
        console.error("[CategoryTagInput] Failed to create:", error);
      }
    }

    onChange(newValue);
  };

  return (
    <TagInput
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      suggestionsEndpoint="/api/company-classification/terms?field=category"
    />
  );
}
